import { createFileRoute, Link } from "@tanstack/react-router";
import type { ReactNode } from "react";

export const Route = createFileRoute("/privacy")({
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <main className="mx-auto max-w-[900px] px-5 py-8 sm:px-8 sm:py-12">
      <Link
        to="/"
        className="font-mono text-[12px] uppercase tracking-[0.12em] text-fg-muted transition-colors hover:text-fg"
      >
        Runboom
      </Link>
      <h1 className="mt-8 font-display text-[52px] leading-[46px] tracking-[0] text-fg sm:text-[76px] sm:leading-[66px]">
        Privacy
      </h1>
      <p className="mt-5 max-w-[70ch] font-mono text-[13px] uppercase leading-6 tracking-[0.08em] text-fg-muted">
        Runboom uses Strava data only to show each connected athlete their own
        race predictions, best efforts, training summary, and recent synced
        runs. We do not sell Strava data, use it for advertising, or show one
        athlete's Strava data to another athlete without explicit consent.
      </p>

      <div className="mt-10 space-y-8 border-t border-border pt-8 font-mono text-[13px] leading-6 text-fg-muted">
        <PolicySection title="Data we request">
          We request Strava OAuth access so an athlete can connect their account.
          The product reads athlete profile information and recent activity data
          needed to calculate race predictions and show proof of the runs used.
        </PolicySection>

        <PolicySection title="How we use Strava data">
          We calculate personal race-time predictions from the athlete's own
          best efforts, weekly run volume, recent long run, elevation, and run
          frequency. These calculations are deterministic product logic and are
          not used to train artificial intelligence or machine learning models.
        </PolicySection>

        <PolicySection title="Storage and deletion">
          Strava-derived activity summaries are cached for no more than seven
          days. Athletes can disconnect from Runboom, which deletes stored
          tokens and cached Strava-derived summaries. Strava deauthorization
          webhook events also delete stored tokens and cached Strava-derived
          data.
        </PolicySection>

        <PolicySection title="Security">
          Runboom uses OAuth rather than collecting Strava passwords. API calls
          are made over HTTPS, and refresh tokens are stored server-side. We keep
          access scoped to the product features the athlete uses.
        </PolicySection>

        <PolicySection title="Contact">
          Questions or deletion requests can be sent to marc@ollie.health.
        </PolicySection>
      </div>
    </main>
  );
}

function PolicySection({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  return (
    <section>
      <h2 className="font-mono text-[12px] uppercase tracking-[0.12em] text-fg">
        {title}
      </h2>
      <p className="mt-2">{children}</p>
    </section>
  );
}
